import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__media",
  "use": "icon__media-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__media\"><title>Artboard</title><path d=\"M22.267 18H1.733C.778 18 0 17.237 0 16.3V3.7C0 2.763.778 2 1.733 2h20.534C23.222 2 24 2.763 24 3.7v12.6c0 .937-.778 1.7-1.733 1.7zM22 4H2v12h20V4zM6 20h12a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol